<template>
    <bar-chart
        :data="chartData"
        :library="chartOptions"
        :height="300"
    />
</template>

<script>
import { defineComponent } from 'vue'
import { BarChart } from 'vue-chartkick'

export default defineComponent({
    name: 'CommissionBarChart',
    components: { BarChart },
    props: {
        commissionData: {
            type: Array,
            required: true
        }
    },
    computed: {
        chartData() {
            // Sort by count descending and take top 10
            const sorted = this.commissionData
                .sort((a, b) => b.count - a.count)
                .slice(0, 10)
                .reverse(); // Reverse so highest is at top

            return sorted.map(d => [`${d.commission_after}%`, parseInt(d.count)]);
        },
        chartOptions() {
            return {
                colors: ['#007bff'],
                scales: {
                    x: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Number of Validators'
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'New Commission Rate'
                        }
                    }
                },
                indexAxis: 'y' // This makes it horizontal
            };
        }
    }
})
</script>